import {  Component, output, signal } from '@angular/core';

@Component({
  selector: 'app-mock-recaptcha',
  imports: [],
  templateUrl: './mock-recaptcha.html',
  styleUrl: './mock-recaptcha.scss',
  standalone: true
})
export class MockRecaptcha {
  readonly captchaResolved = output<boolean>();

  protected verified = signal(false);
  protected loading = signal(false);

  protected onCheck(): void {
    if (this.verified() || this.loading()) return;

    this.loading.set(true);

    setTimeout(() => {
      this.loading.set(false);
      this.verified.set(true);
      this.captchaResolved.emit(true);
    }, 1400);
  }
}
